module.exports = __webpack_public_path__ + "static/media/devices-empty.43f81560.png";